<template>
	<div>
		<!--弹出框-->
		<el-form :model="ruleForm" :rules="rules"  ref="ruleForm" label-width="100px" class="demo-ruleForm" style="height: 100%">
			<el-dialog title="用户管理" :visible.sync="dialogVisible" :modal="false" v-dialogDrag :before-close="handleClose" :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false">
				<el-row>
					<el-col :span="24" class="rowTops">
						<el-form-item type="type" label="上级菜单" prop="sjcd">
							<el-input v-model.trim="ruleForm.sjcd" placeholder="上级菜单" @focus="focusval($event)" @blur="blurval1($event)"></el-input>
						</el-form-item>
						<transition name="el-zoom-in-center">
							<div v-show="khdwshow" class="rowTopa">
								<el-tree :data="datatree" class="paddingtree" :expand-on-click-node="false" :highlight-current='true' :default-expand-all="true" :props="defaultProps" @node-click="handleNodeClick" node-key='id' ref="treeList" :filter-node-method="filterNode" :default-expanded-keys='[treesid]'>
								</el-tree>
							</div>
						</transition>
					</el-col>
					<el-col :span="24">
						<el-form-item type="type" label="类型" prop="leix">
							<el-select v-model="ruleForm.leix" placeholder="请选择" style="width: 100%;" class="project-select">
								<el-option v-for="item in leixlist" :key="item.value" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>

					<el-col :span="24" v-if="ruleForm.leix==1||ruleForm.leix==0">
						<el-form-item type="type" label="菜单名称" prop="cdmc">
							<el-input type="type" placeholder="菜单名称" class="from-el-input" v-model.trim="ruleForm.cdmc"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24" v-if="ruleForm.leix==1">
						<el-form-item type="type" label="href" prop="href">
							<el-input type="type" placeholder="href" class="from-el-input" v-model.trim="ruleForm.href"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24" v-if="ruleForm.leix==1||ruleForm.leix==0">
						<el-form-item type="type" label="排序" prop="paix">
							<el-input type="type" placeholder="排序" class="from-el-input" v-model.trim="ruleForm.paix"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24" v-if="ruleForm.leix==1||ruleForm.leix==0">
						<el-form-item type="type" label="icon" prop="icon">
							<el-input type="type" placeholder="icon" class="from-el-input" v-model.trim="ruleForm.icon"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24" v-if="ruleForm.leix==2">
						<el-form-item type="type" label="按钮名称" prop="anmc">
							<el-input type="type" placeholder="按钮名称" class="from-el-input" v-model.trim="ruleForm.anmc"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24" v-if="ruleForm.leix==1||ruleForm.leix==2">
						<el-form-item type="type" label="权限" prop="quanx">
							<el-input type="type" placeholder="权限" class="from-el-input" v-model.trim="ruleForm.quanx"></el-input>
						</el-form-item>
					</el-col>

					<!--<el-col :span="24">
						<el-form-item type="type" label="描述" prop="note">
							<el-input type="type" placeholder="描述" class="from-el-input" v-model.trim="ruleForm.note"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24" v-if="ruleForm.leix==1">
						<el-form-item type="type" label="页面类型" prop="zoom">
							<el-input type="type" placeholder="0或1" class="from-el-input" v-model.trim="ruleForm.zoom"></el-input>
						</el-form-item>
					</el-col>-->


				</el-row>

				<span slot="footer" class="dialog-footer">
                    <el-form-item>
                        <el-button round @click="empty()" type="warning">取消</el-button>
                        <el-button round v-if="state=='xz'" type="primary" @click="deteRmine('ruleForm','xz')">保 存</el-button>
                        <el-button round v-if="state=='bj'" type="primary" @click="deteRmine('ruleForm','bj')">保 存</el-button>
                    </el-form-item>
                </span>
			</el-dialog>
		</el-form>
		<!--弹出框-->
	</div>
</template>

<script>
	import {addmenutree,menusave,menuupdate} from "@/api/api";

	export default {
		props: {
			mystate: Array
		},
		data() {
			return {
				dialogVisible: true,
				sjcdid: '', //上级菜单id
				state: '',
				ruleForm: {
					sjcd: '',
					leix: null,
					href: '',
					icon: '',
					quanx: '',
					anmc: '',
					cdmc: '',
					paix: '',
					note:'',
					zoom:'',
				},
				rules: {
					sjcd: [
						{ required: true, message: "请输入必填项", trigger: "change" },
					],
					cdmc: [
						{ required: true, message: "请输入必填项", trigger: "blur" },

					],
					paix: [
						{ required: true, message: "请输入必填项", trigger: "blur" },

					],
					jsmc: [
						{ required: true, message: "请输入必填项", trigger: "blur" },
						{ min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
					],
					bzxx: [
						{ required: true, message: "请输入必填项", trigger: "blur" },
						{ min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
					],
					icon: [
						{ required: true, message: "请输入必填项", trigger: "blur" },
						{ min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
					],
					leix: [
						{ required: true, message: "请输入必填项", trigger: "change" },

					],
					anmc: [
						{ required: true, message: "请输入必填项", trigger: "blur" },
						{ min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
					],
					quanx: [
						{ required: true, message: "请输入必填项", trigger: "blur" },
						{ min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
					],
					href:[
						{ required: true, message: "请输入必填项", trigger: "blur" },
						{ min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
					],
					note: [
						{ required: false, message: "请输入必填项", trigger: "blur" },
						{ min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
					],
					zoom:[
						{ required: true, message: "请输入必填项", trigger: "blur" },
						//{ min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
					],
				},
				leixlist: [
					{ name: '目录', id: 0 },
					{ name: '菜单', id: 1 },
					{ name: '按钮', id: 2 },
				],
				datatree: [],
				defaultProps: { /// tree设置
					children: 'children',
					label: 'name'
				},
				khdwshow: false,
				treesid: '',
				row:null,
			};
		},
		created() {
			//初始化数据
		},
		components: {},
    watch: {
      "ruleForm.sjcd": {
        handler(newval, oldval) {
          this.$refs.treeList.filter(newval);
        },
      },
    },
		methods: {
			cancel() {

			},
			deteRmine(formName, type) {
				console.log(this.ruleForm.cdmc)
				this.$refs[formName].validate(valid => {
					if(valid) {
						if(type == 'xz') {
							let params = null;
							if(this.ruleForm.leix == 0) {
								params = {
									parentId: this.sjcdid,
									type: this.ruleForm.leix,
									name: this.ruleForm.cdmc,
									orderNum: this.ruleForm.paix,
									icon: this.ruleForm.icon,
									//note:this.ruleForm.note
								}
							}
							if(this.ruleForm.leix == 1) {
								params = {
									parentId: this.sjcdid,
									type: this.ruleForm.leix,
									name: this.ruleForm.cdmc,
									url: this.ruleForm.href,
									orderNum: this.ruleForm.paix,
									icon: this.ruleForm.icon,
									perms: this.ruleForm.quanx,
									//note:this.ruleForm.note,
									//zoom:Number(this.ruleForm.zoom),
								}
							}
							if(this.ruleForm.leix == 2) {
								params = {
									parentId: this.sjcdid,
									type: this.ruleForm.leix,
									name: this.ruleForm.anmc,
									perms: this.ruleForm.quanx,
									note:this.ruleForm.note
								}
							}

							menusave(params).then((res) => {

									console.log(res)
								if(res.code === 200) {
									this.$notify({
										title: "提示",
										message: "提交成功",
										type: "success"
									});
									this.dialogVisible = false;
									this.$emit("adddata", {
										dialogVisible: this.dialogVisible
									});
								} else {
									this.$notify({
										title: "提示",
										message: res.message,
										type: "warning"
									});
								}

							})
						}else{
							let params = null;
							if(this.ruleForm.leix == 0) {
								params = {
									parentId: this.sjcdid,
									type: this.ruleForm.leix,
									name: this.ruleForm.cdmc,
									orderNum: this.ruleForm.paix,
									icon: this.ruleForm.icon,
									id:this.row.id,
									//note:this.ruleForm.note
								}
							}
							if(this.ruleForm.leix == 1) {
								params = {
									parentId: this.sjcdid,
									type: this.ruleForm.leix,
									name: this.ruleForm.cdmc,
									url: this.ruleForm.href,
									orderNum: this.ruleForm.paix,
									icon: this.ruleForm.icon,
									perms: this.ruleForm.quanx,
									id:this.row.id,
									//note:this.ruleForm.note,
									//zoom:Number(this.ruleForm.zoom),
								}
							}
							if(this.ruleForm.leix == 2) {
								params = {
									parentId: this.sjcdid,
									type: this.ruleForm.leix,
									name: this.ruleForm.anmc,
									perms: this.ruleForm.quanx,
									id:this.row.id,
									//note:this.ruleForm.note
								}
							}

							menuupdate(params).then((res) => {

								if(res.code === 200) {
									this.$notify({
										title: "提示",
										message: "提交成功",
										type: "success"
									});
									this.dialogVisible = false;
									this.$emit("adddata", {
										dialogVisible: this.dialogVisible
									});
								} else {
									this.$notify({
										title: "提示",
										message: res.message,
										type: "warning"
									});
								}

							})
						}

					} else {
						this.$notify({
							title: '提示',
							message: '请填写完整后再提交',
							type: 'warning'
						})
						return false
					}
				});
			},
			focusval(e) {
				this.khdwshow = true
			},
			blurval1(e) {
				let _this = this
				setTimeout(function() {
					_this.khdwshow = false
				}, 200)
			},
			empty() {
				this.dialogVisible = false;
				this.$emit("getcancel", {
					dialogVisible: this.dialogVisible
				});
			},
			optionsChange() {

			},
      filterNode(value, data) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
      },
			handleNodeClick(data, e) {
				console.log(data)
				this.sjcdid = data.id;
				this.ruleForm.sjcd = data.name;
			},

			handleClose() {
				this.dialogVisible = false;
				this.$emit("getcancel", {
					dialogVisible: this.dialogVisible
				});
			}
		},
		mounted() {
			console.log(this.mystate)
			this.state = this.mystate[0];
			this.row = this.mystate[1];
			addmenutree({}).then((res) => {
				if(res.code == 200) {
					this.datatree = [res.data];

          if(this.mystate[0] == 'bj') {
          	this.sjcdid = this.mystate[1].parentId;
          	this.ruleForm.leix = this.mystate[1].type;
          	this.ruleForm.cdmc = this.mystate[1].name;
          	this.ruleForm.href = this.mystate[1].url;
          	this.ruleForm.paix = this.mystate[1].orderNum;
          	this.ruleForm.icon = this.mystate[1].icon;
          	this.ruleForm.quanx = this.mystate[1].perms;
          	this.ruleForm.note = this.mystate[1].note;
          	this.ruleForm.zoom = this.mystate[1].zoom;
          	this.$nextTick(function() {
          		this.$refs.treeList.setCurrentKey(this.sjcdid);
          		this.ruleForm.sjcd = this.$refs.treeList.getCurrentNode().name;
          	})
          }
				} else {
					this.$notify({
						title: "提示",
						message: res.message,
						type: "success",
					});
				}
			})
		}
	};
</script>

<style scoped="scoped">
	>>>.el-dialog {
		width: 700px;
	}

	>>>.el-dialog__body {
		height: 450px;
		overflow: auto;
	}

	.trees {
		width: 98%;
		float: left;
		max-height: 300px;
		height: 60px;
		line-height: 30px;
		padding-left: 2%;
		margin-top: 5px;
	}

	.rowTops {
		position: relative;
	}

	.rowTopa {
		position: absolute;
		left: 100px;
		top: 37px;
		right: 0px;
		margin: auto;
		max-height: 300px;
		background: #fff;
		border: 1px solid #e3e3e3;
		z-index: 100;
		border-radius: 5px;
		overflow: auto;
		padding-bottom: 10px;
	}
</style>
